import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IProvince } from '@pages/adminsettings/area/area.interface';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalConfig } from '@shared/components/modal/modal.interface';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { BaseService } from '@services/base-service.service';
import { API } from '@config/constants/api.constant';

@Component({
  selector: 'app-input-listbox-plant-type',
  templateUrl: './input-listbox-plant-type.component.html',
  styleUrls: ['./input-listbox-plant-type.component.scss'],
})
export class InputListboxPlantTypeComponent implements OnInit, OnChanges {
  @ViewChild('modalForm') private modalFormComponent: ModalComponent;

  @Input() required: boolean = false;
  @Input() label: string = 'Jenis Tanaman';
  @Input() chipsListData: any[];
  @Input() ctaLabelAddItems: string = 'Tambahkan';
  @Input() ctaLabelOpenModalForm: string = 'Pilih Jenis Tanaman';
  @Input() searchLabel: string = 'Jenis Tanaman';
  @Input() modalConfirmTitle: string = 'Pilih Jenis Tanaman';
  @Input() isPlantTypeList: boolean = true;

  @Output() selectionOutput = new EventEmitter();

  listbox_selectedItems: any[] = [];
  modalFormConfig: ModalConfig;
  searchKeyword: string = '';
  listbox_listItems: any[] = [];
  STRING_CONSTANTS = STRING_CONSTANTS;

  constructor(private baseService: BaseService) {}

  ngOnInit(): void {
    this.initListBox().then(() => null);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.listBoxItems && !changes.listBoxItems.firstChange) {
      this.listbox_listItems = changes.listBoxItems.currentValue;
    }

    if (changes.chipsListData && !changes.chipsListData.firstChange) {
      this.chipsListData = changes.chipsListData.currentValue;
    }
  }

  async initListBox(): Promise<void> {
    this.modalFormConfig = {
      modalTitle: this.modalConfirmTitle,
    };
    if (this.isPlantTypeList) {
      this.baseService.getData<any>(API.GET_PLANT_TYPE).subscribe((value) => {
        if (value) {
          this.listbox_listItems = value.data;
        }
      });
    }
  }

  handleChangeSelection() {
    this.listbox_selectedItems = this.listbox_listItems.filter((val: any) => {
      return val.selected;
    });
    this.selectionOutput.emit(this.listbox_selectedItems);
  }

  handleDataOutput(items: IProvince[]) {
    this.listbox_selectedItems = items;
    this.selectionOutput.emit(this.listbox_selectedItems);
  }

  handleAddChipsList() {
    this.toggleShowSelectedList();
    this.modalFormComponent.close();
  }

  toggleShowSelectedList() {
    this.chipsListData = this.listbox_selectedItems;
  }

  handleOpenModalForm() {
    this.modalFormComponent.open();
  }
}
